import { types, flow, cast, getRoot } from 'mobx-state-tree';
import { startNexonlink, stopNexonlink } from 'service/nexonlink';
import { IRootStore } from '../root';
import { SDKapi } from 'service/axios-api';

const NexononGid: { [key: string]: string } = {
    live: '2325',
    pre: '2324',
    test: '2323',
};

const { application } = window;

const NexonlinkGame = types.model('NexonlinkGame', {
    gid: types.string,
    title: types.string,
    ngmGameCode: types.string,
    arenaProductId: types.string,
});

export const NexonlinkStore = types
    .model('NexonlinkStore', {
        games: types.array(NexonlinkGame),
        streamingInfo: types.map(types.boolean),
        nexononGid: application.params.nexonon_service_id || NexononGid[application.params.environment] || '2325',
    })
    .views((self) => {
        const views = {
            get root(): IRootStore {
                return getRoot<IRootStore>(self);
            },
            getGid(productId: string) {
                return self.games.find((game) => game.arenaProductId === productId)?.gid || '';
            },
            isStreaming(productId: string) {
                const gid = views.getGid(productId);
                return !!self.streamingInfo.get(gid);
            },
        };
        return views;
    })
    .actions((self) => {
        const actions = {
            fetchGames: flow(function* () {
                if (self.root.systemInfo.onMac) {
                    return;
                }
                try {
                    const res: any = yield SDKapi.get('/contents/nx-link/games/{nexonlinkRegion}', {
                        headers: {
                            'client-type': 'arena-launcher',
                            gid: self.nexononGid,
                            locale: self.root.systemInfo.locale.replace('-', '_'),
                        },
                    });

                    if (res.data.code === 0) {
                        self.games = cast(res.data.result.games);
                    }
                } catch (err) {
                    self.games = cast([]);
                }
            }),
            start: flow(function* (options?: any) {
                if (application.globalUserNo) {
                    return yield startNexonlink(application.globalUserNo, options);
                }
            }),
            stop() {
                stopNexonlink();
            },
            isSupport(productId: string) {
                if (self.games.length === 0) {
                    return false;
                }

                return !!self.games.find((game) => game.arenaProductId === productId);
            },
            setStreamingInfo(gid: string, streaming: boolean) {
                self.streamingInfo.set(gid, streaming);
            },
            convGidToProductId(gid: string) {
                return self.games.find((game) => game.gid === gid)?.arenaProductId || gid;
            },
            clearStreamingInfo() {
                self.streamingInfo.clear();
            },
        };
        return actions;
    });
